import React from 'react';
import useSetupChecklistState, { type SetupChecklistUpdateCompany } from './useSetupChecklistState';
import { type SetupChecklistStateCompany } from './SetupChecklist';

function useSetupChecklist(): {
  setupChecklistState: SetupChecklistStateCompany;
  updateSetupChecklistState: (update: SetupChecklistUpdateCompany['state']) => void;
  remainingItemsCount: number;
} {
  const [setupChecklistState, updateSetupChecklistState] = useSetupChecklistState();

  const remainingItemsCount = React.useMemo(
    () => Object.values(setupChecklistState).filter((done) => !done).length,
    [setupChecklistState]
  );

  return {
    setupChecklistState,
    updateSetupChecklistState,
    remainingItemsCount,
  };
}

export default useSetupChecklist;
